const state = {
  filter: {}
}

const mutations = {
  SET_FILTER: (state, data) => {
    state.filter = data
  }
}

const actions = {
  // user login
  setFilter({ commit }, data) {
    commit('SET_FILTER', data)
  }
}

export default {
  state,
  mutations,
  actions
}
